<template>
  <div>
    <el-button size="small" class="margin-bottom-10" type="primary" @click="tojobAuth()" round>
      <i class="fa fa-plus"></i> 职务授权
    </el-button>
    <el-table
          class="list-table"
          ref="multipleTable"
          :data="authList"
          border
          tooltip-effect="dark"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      >
      <template slot="empty">
        <div class="no-data">暂无数据！</div>
      </template>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="jobId" label="职务编号" width="120"></el-table-column>
      <el-table-column prop="jobName" label="职务名称" width="300"></el-table-column>
      <el-table-column prop="roles" label="角色" min-width="240">
        <template slot-scope="scope">
          <el-tag class="margin-right-5" size="small" effect="plain" v-for="(role, index) in scope.row.roles" :key="index">{{ role.name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-button @click="tojobAuth(scope.row)" type="text" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
          <el-button @click="deleteAuth(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <page-bar v-model="page" @change="fetchData"></page-bar>

    <el-dialog :title="curAuth ? '编辑授权' : '添加授权'" :visible.sync="dialogVisible" :destroy-on-close="true" width="780px" class="form-dialog">
      <el-form :rules="rules" ref="jobForm" label-width="80px">
        <el-form-item label="职务" prop="name" :options="jobIds">
          <el-select v-model="jobIds" multiple placeholder="请选择" style="width: 40%">
            <el-option v-for="job in jobList" :key="job.id" :value="job.id" :label="job.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <template>
            <el-transfer v-model="roleIds" :props="props" :data="roleList" :titles="['角色名称', '配置角色']"></el-transfer>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="doClose()"><i class="fa fa-close"></i> 关闭</el-button>
        <el-button type="primary" @click="saveJobAuth()"><i class="fa fa-save"></i> 保存 </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { batchSaveJobAuth, fetchJobAuth, remove } from '@/api/system/auth'
import PageBar from '@components/PageBar'
import { handleConfirm } from '@utils/confirm'
import { fetchAll } from '@api/system/role'
import { fetchList } from '@api/system/job'

export default {
  created() {
    this.fetchData()
  },
  components: { PageBar },
  methods: {
    fetchData() {
      fetchJobAuth({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        query: this.page.param
      }).then(resp => {
        this.authList = resp.data.result
      })
    },
    deleteAuth(val) {
      handleConfirm('你确定要回收该职务的所有授权吗, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message)
          this.fetchData()
        })
      })
    },
    tojobAuth(row) {
      this.curAuth = row
      this.dialogVisible = true

      this.getJobEcho()
      this.roleTransfer()
    },
    roleTransfer() {
      fetchAll().then(resp => {
        this.roleList = resp.data.result
      })
    },
    saveJobAuth() {
      batchSaveJobAuth(this.jobIds, this.roleIds).then(resp => {
        if (resp.status === 200) {
          this.$message.success(resp.data.message)
          this.fetchData()
          this.dialogVisible = false
        }
      })
    },
    doClose(){
      this.dialogVisible = false
    },
    getJobEcho() {
      fetchList().then(resp => {
        this.jobList = resp.data.result
      })

      if(!this.curAuth){
        this.jobIds = []
        this.roleIds = []
      }else{
        this.jobIds = [this.curAuth.jobId]
        this.roleIds = this.curAuth.roles.map(r=> r.id)
      }
    }
  },
  data() {
    return {
      page: {
        pageSize: 20,
        pageNo: 1
      },
      authList: [],
      curAuth: null,
      dialogVisible:false,
      roleIds: [],
      roleList: [],
      jobIds: [],
      jobList: [],
      echoJob: {},
      props: {
        key: 'id',
        label: 'name'
      },
      jobForm: {},
      rules: {
        name: [
          { required: true, message: '请选择职务', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        role: [{ required: true, message: '请选择角色', trigger: 'blur' }]
      }
    }
  }
}
</script>

<style scoped></style>
